import { useAuthorization } from "./authorization-service-impl";
import { GrupoUsuarioEnum } from "@/.shared/.api";

export function useGrupoUsuarioChecker() {
    const auth = useAuthorization();

    const esBackoffice = () => {
        return auth.isGrupo(GrupoUsuarioEnum.Backoffice);
    };

    const esInmobiliario = () => {
        return auth.isGrupo(GrupoUsuarioEnum.Inmobiliaria);
    };

    const esColaborador = () => {
        return auth.isGrupo(GrupoUsuarioEnum.Colaboradores);
    };

    const esAgente = () => {
        return auth.isGrupo(GrupoUsuarioEnum.Inmobiliaria) || auth.isGrupo(GrupoUsuarioEnum.Colaboradores);
    };

    return {
        esBackoffice,
        esInmobiliario,
        esColaborador,
        esAgente,
    };

}